import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
export default class ProductHeader {
    constructor() {
        this.ready();
    }

    ready() {
        const hash = window.location.hash;
        const image = document.querySelectorAll('.product-image-container');
        const imageMobile = document.querySelectorAll('.product-image-container-mobile');
        const imageMobileNt = document.querySelectorAll('.product-image-container-nutritional-table');

        document.querySelectorAll('.product-image').forEach((el, i) => {
            if (hash == '#1000') {
                if (i == 0) {
                    el.classList.add('hidden');
                }
            } else {
                if (i == 1) {
                    el.classList.add('hidden');
                }
            }
        });

        document.querySelectorAll('.product-image-mobile').forEach((el, i) => {
            if (hash == '#1000') {
                if (i == 0) {
                    el.classList.add('hidden');
                }
            } else {
                if (i == 1) {
                    el.classList.add('hidden');
                }
            }
        });

        document.querySelectorAll('.product-image-nutritional-table').forEach((el, i) => {
            if (hash == '#1000') {
                if (i == 0) {
                    el.classList.add('hidden');
                }
            } else {
                if (i == 1) {
                    el.classList.add('hidden');
                }
            }
        });

        window.addEventListener('scroll', function () {
            const scrollPosition = window.scrollY;
            if (scrollPosition > 50) {
                image[0].classList.add('active');
                imageMobile[0].classList.add('active');
                if (image.length > 1) {
                    image[1].classList.add('active');
                    imageMobile[1].classList.add('active');
                }
            } else {
                image[0].classList.remove('active');
                imageMobile[0].classList.remove('active');
                if (image.length > 1) {
                    image[1].classList.remove('active');
                    imageMobile[1].classList.remove('active');
                }
            }
        });
    }
}
if (document.querySelector('.product-sticky')) {
    new ProductHeader();
}
